  <div class="footer-subcontainer">
    <span>
      <a class="crc-link" [routerLink]="UrlConstants.privacyUrl">{{ "privacyTerms.head" | translate}}</a>
      @if(accessible(RoleConstants.VIEW_HELP_PAGE))
      {
        |
        <a class="crc-link" (click)="openHelpPDF()"
           target="_blank" >{{ "general.label.help" | translate }}</a>
      }

      @if(sessionDetails && sessionDetails.userName && accessible(RoleConstants.CUSTOMER) && !accessible(RoleConstants.VIEW_CUSTOM_CONTACT_US_PAGE))
      {
        |
        <a class="crc-link" [routerLink]="UrlConstants.customerFeedBackUrl"  (click)="onFeedbackLinkClick()">
        {{"feedback.opinion.box.link.submitFeedback"|translate}}
      </a>
      }

      @if(sessionDetails && sessionDetails.userName!==null && (accessible(RoleConstants.PARTNER)))
      {
        |
        <a class="crc-link" [routerLink]="UrlConstants.partnerFeedBackUrl"  (click)="onFeedbackLinkClick()"> {{"feedback.opinion.box.link.submitFeedback"|translate}}</a>
      }

      @if(showChangePassword()){
        {{'|'}}
        <a class="crc-link" [routerLink]="UrlConstants.changePasswordUrl">
        {{"userprofile.label.changePassword"|translate}}
        </a>
      }

    </span>
    <span class="crc-link">
      {{ "general.text.copyright" | translate:{'0': year} }}
    </span>
  </div>
